"use strict";
var $dyn;
(function ($dyn) {
    var serverForm;
    (function (serverForm) {
        var UpdateModelManager;
        (function (UpdateModelManager) {
            UpdateModelManager._collectionChanges = {};
            UpdateModelManager._modelChanges = {};
            UpdateModelManager._groupingChanges = {};
            function pushModelCollectionChange(modelCollectionId) {
                if (UpdateModelManager._collectionChanges === undefined) {
                    UpdateModelManager._collectionChanges = {};
                }
                if (modelCollectionId) {
                    UpdateModelManager._collectionChanges[modelCollectionId] = true;
                }
            }
            UpdateModelManager.pushModelCollectionChange = pushModelCollectionChange;
            function pushModelChange(modelId) {
                if (UpdateModelManager._modelChanges === undefined) {
                    UpdateModelManager._modelChanges = {};
                }
                if (modelId) {
                    UpdateModelManager._modelChanges[modelId] = true;
                }
            }
            UpdateModelManager.pushModelChange = pushModelChange;
            function pushGroupingChange(modelCollectionId) {
                if (UpdateModelManager._groupingChanges === undefined) {
                    UpdateModelManager._groupingChanges = {};
                }
                if (modelCollectionId) {
                    UpdateModelManager._groupingChanges[modelCollectionId] = true;
                }
            }
            UpdateModelManager.pushGroupingChange = pushGroupingChange;
            function raiseChanges() {
                // _collectionChanges contains the collectionIds that have any of their models updated during this request processing. Consumers bound to the modelcollection
                // are notified through _itemsChanged event that values of some items in this collection have been updated. The consumers can subscibe to this event to when to update data
                $dyn.log.server && $dyn.log.server("ServerForm: Changes to model collections %o", UpdateModelManager._collectionChanges);
                for (var modelCollection in UpdateModelManager._collectionChanges) {
                    if (UpdateModelManager._collectionChanges[modelCollection]) {
                        $dyn.log.verboseServer && $dyn.log.verboseServer("ServerForm: Rows to update in %s: %o", modelCollection, Object.keys(UpdateModelManager._collectionChanges[modelCollection]));
                        var collection = serverForm.ModelManager.getModelCollection(modelCollection);
                        if (collection && collection._itemsChangedHost) {
                            collection._itemsChangedHost.raise();
                        }
                        else if (!collection) {
                            $dyn.logWarning("ServerForm: Invalid collection ", modelCollection);
                        }
                    }
                }
                for (var modelCollection in UpdateModelManager._groupingChanges) {
                    if (UpdateModelManager._groupingChanges[modelCollection]) {
                        var collection = serverForm.ModelManager.getModelCollection(modelCollection);
                        if (collection && collection.executeGroupingActions) {
                            collection.executeGroupingActions();
                        }
                    }
                }
                // Raise changes on model
                // _modelChanges contains the modelIds that have any of their properties updated during this request processing. Consumers bound to the model directly (example form root model)
                // are notified through propertyChanged event that model has been updated. The consumers can subscibe to this event to when to update data
                $dyn.log.server && $dyn.log.server("ServerForm: Changes to model  %o", UpdateModelManager._modelChanges);
                // tslint:disable-next-line: forin
                for (var modelId in UpdateModelManager._modelChanges) {
                    $dyn.log.verboseServer && $dyn.log.verboseServer("ServerForm: Full update in %s: %o", modelId, UpdateModelManager._modelChanges[modelId]);
                    var model = serverForm.ModelManager.getModel(modelId);
                    if (model && model._propertyChangedHost) {
                        model._propertyChangedHost.raise();
                    }
                    else if (!model) {
                        $dyn.logWarning("ServerForm: Invalid model", modelId);
                    }
                }
                UpdateModelManager.clearChanges();
            }
            UpdateModelManager.raiseChanges = raiseChanges;
            function clearChanges() {
                // tslint:disable-next-line: forin
                for (var formId in serverForm.ModelManager.collections) {
                    // The case when we have non-form related collection
                    var formCollections = serverForm.ModelManager.collections[formId];
                    if (serverForm.isModelCollection(formCollections)) {
                        formCollections._pendingCollectionChange = undefined;
                    }
                    else {
                        // We need to iterate over form collections
                        for (var modelCollection in formCollections) {
                            if (formCollections[modelCollection]) {
                                formCollections[modelCollection]._pendingCollectionChange = undefined;
                            }
                        }
                    }
                }
                UpdateModelManager._collectionChanges = undefined;
                UpdateModelManager._modelChanges = undefined;
                UpdateModelManager._groupingChanges = undefined;
            }
            UpdateModelManager.clearChanges = clearChanges;
        })(UpdateModelManager = serverForm.UpdateModelManager || (serverForm.UpdateModelManager = {}));
    })(serverForm = $dyn.serverForm || ($dyn.serverForm = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=UpdateModelManager.js.map
